export { default } from './ownerDocument';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/ownerDocument/index.js
// module id = 375
// module chunks = 22